import React from "react";
import { Navigate, useLocation } from "react-router-dom";

type AuthGuardProps = {
  children: React.ReactNode;
  allowedRoles?: number[];
};

function AuthGuard({ children, allowedRoles }: AuthGuardProps) {
  const location = useLocation();

  const accessToken = localStorage.getItem("accessToken");
  const roleId = Number(localStorage.getItem("roleId"));

  const isAuthenticated = !!accessToken;

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(roleId)) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}

export default AuthGuard;
